import React from 'react';
import { Footer } from '../Common/Footer';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import Buyer from '../../Models/Buyer';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import Profile from '../../Models/Profile';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class BuyerProfile extends React.Component {
    constructor(props) {
        super(props);
        // notifyA = () => toast('Wow so easy !', {containerId: 'A'});
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert('ログインしてください')
            window.location.href = '/login';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            user: logged_user,
            modal: false,
            profession: '',
            photo_id: null,
            utility: null,
            residential: [],
            services: [],
            portfolio: [],
            sex: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            username: '',
            phone: '',
            email: '',
            creditcard: '',
            t_account: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getResidentials().then(res => {
            if (res.data.area != null) {
                this.setState({ residential: res.data.area })
            }
        })
        Profile.getSex().then(res => {
            if (res.data.sex != null) {
                this.setState({ sex: res.data.sex })
            }
        })
        Profile.getBasics(this.state.user.id).then(res => {
            if (res.data.payloads != null) {
                this.setState({ profile: res.data.payloads })
                this.setState({ profession: res.data.payloads.profession })
                this.setState({ photo_id: res.data.payloads.pid })
                this.setState({ profile_picture: res.data.payloads.profile_image })
                this.setState({ utility: res.data.payloads.ut })
                this.setState({ x: res.data.payloads.sex })
                this.setState({ area: res.data.payloads.residential_area })
                this.setState({ address: res.data.payloads.address })
            }
        })
        Profile.getConfiguration(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ username: res.data.payload.first_name })
                this.setState({ phone: res.data.payload.phone })
                this.setState({ email: res.data.payload.email })
                this.setState({ creditcard: res.data.payload.credit_card })
                this.setState({ t_account: res.data.payload.transfer_account })
            }
        })
    }

    onChangePro(e) {
        this.setState({ profile_picture: e.target.files[0] })
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleAll() {
        this.setState({
            modal: false
        });
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 50))
            )
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.state.area = this.refs.Area.value;
        this.state.x = this.refs.Sex.value;
        Profile.checkusername(this.state.username, this.state.user.id).then(res => {
            if (res.data.status != 404) {
                this.setState({ username: '' })
                alert("このユーザー名は既に利用されています");
                return;
            } else {
                const formData = new FormData();
                formData.append('user_id', this.state.user.id)
                formData.append('profession', this.state.profession)
                formData.append('profile_picture', this.state.profile_picture)
                formData.append('sex', this.state.x)
                formData.append('area', this.state.area)
                formData.append('address', this.state.address)
                formData.append('username', this.state.username)
                formData.append('phone', this.state.phone)
                formData.append('email', this.state.email)
                formData.append('creditcard', this.state.creditcard)
                formData.append('t_account', this.state.t_account)
                axios({
                    method: 'post',
                    url: 'https://share-work.jp/backend/update-basic-profile',
                    // url: 'http://192.168.1.110/sharework_back_v2/public/backend/update-basic-profile',
                    // url: 'http://share-work.jp/backend/update-basic-profile',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    if (res.data.message === "Success") {
                        toast('Wow so easy !', { containerId: 'A' });
                        window.localStorage.setItem('pro_pic', JSON.stringify(res.data.profile_pic))
                        window.localStorage.setItem('pro_name', JSON.stringify(this.state.username))
                        window.location.reload()
                    }
                })
            }
        })
    }

    profileImage() {
        if (this.state.profile.img === '' || this.state.profile.img === null) {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img alt="" src={require("../../assets/images/image1.jpeg")} height="100" width='100' style={{ objectFit: 'cover', borderRadius: "50%" }} />
                </div>
            )
        } else {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img alt="" src={this.state.profile.img} height="100" width='100' style={{ objectFit: 'cover', borderRadius: "50%" }} />
                </div>
            )
        }
    }

    editProfile() {
        return (
            <div className="">
                <Button color="" className="ml-4 mt-3" onClick={this.toggle.bind(this)} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>プロフィルを編集</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} >
                    <ModalHeader toggle={this.toggle.bind(this)}>プロフィール</ModalHeader>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    </button>
                    <ModalBody>
                        <div style={{}}>
                            <form>
                                <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                    <legend style={{ width: "22%", color: "#008dc7", fontSize: "12px" }}>基本プロフィル:</legend>
                                    <div>&nbsp;</div>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <span style={{ fontSize: "13px" }}>プロフィル画像</span>
                                    </div>
                                    {this.profileImage()}

                                    <div>&nbsp;</div>
                                    <div style={{ width: "100%", textAlign: "center", paddingLeft: "15%" }}>
                                        <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)} />
                                    </div>
                                    <div>&nbsp;</div>


                                    <div style={{ fontSize: "13px" }}>性別</div>
                                    <div>
                                        <select ref="Sex" style={{ fontSize: "13px", width: "25%", height: "35px" }}
                                            value={this.state.x} onChange={this.updateValue.bind(this, 'x')}>
                                            <option value="">----</option>
                                            {this.state.sex.map(rp =>
                                                <option value={rp.id} key={rp.id} >
                                                    {rp.description}
                                                </option>
                                            )}
                                        </select>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>都道府県選択</div>
                                    <div>
                                        <select ref="Area" style={{ fontSize: "13px", width: "40%", height: "35px" }}
                                            value={this.state.area} onChange={this.updateValue.bind(this, 'area')}>
                                            <option value="">------</option>
                                            {this.state.residential.map(rp =>
                                                <option value={rp.id} key={rp.id} >
                                                    {rp.area}
                                                </option>
                                            )}
                                        </select>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>住所</div>
                                    <div>
                                        <textarea style={{ fontSize: "13px", width: "70%", height: "80px", border: "1px solid gray", borderRadius: "4px", padding: "2%" }}
                                            value={this.state.address} onChange={this.updateValue.bind(this, 'address')}>
                                        </textarea>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>ユーザー名</div>
                                    <div>
                                        <input value={this.state.username} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'username')}></input>
                                    </div>
                                </fieldset>
                                <div>&nbsp;</div>
                                <fieldset style={{ border: "1px solid #008dc7", padding: "4%" }}>
                                    <legend style={{ width: "25%", color: "#008dc7", fontSize: "12px" }}>プロフィル設定:</legend>
                                    <div style={{ fontSize: "13px" }}>電話番号</div>
                                    <div>
                                        <input value={this.state.phone} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'phone')}></input>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{ fontSize: "13px" }}>メールアドレス</div>
                                    <div>
                                        <input value={this.state.email} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'email')}></input>
                                    </div>
                                    <div>&nbsp;</div>
                                    {/* <div style={{ fontSize: "13px" }}>クレジットカード</div>
                                    <div>
                                        <input value={this.state.creditcard} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 'creditcard')}></input>
                                    </div> 
                                    <div style={{ fontSize: "13px" }}>銀行口座情報</div>
                                    <div>
                                        <textarea style={{ fontSize: "13px", width: "70%", height: "80px", border: "1px solid gray", borderRadius: "4px", padding: "2%" }}
                                            value={this.state.t_account} onChange={this.updateValue.bind(this, 't_account')}>
                                        </textarea>
                                        {/* <input value={this.state.t_account} type="text" style={{
                                            fontSize: "13px", width: "60%", border: "1px solid #d2d2d2", borderRadius: "4px",
                                            padding: "1%", fontSize: "14px"
                                        }} onChange={this.updateValue.bind(this, 't_account')}></input> 
                                    </div>*/}

                                </fieldset>
                                <div>&nbsp;</div>
                                {/* <div style={{ textAlign: "center" }}>
                                    <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</button>&nbsp;
                                            <button onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>更新する</button>
                                </div> */}
                            </form>
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.handleSubmit.bind(this)} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>更新する
                        </Button>
                        {/* <Button color="primary" onClick={this.toggle.bind(this)}>Do Something</Button>{' '} */}
                        <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>キャンセル</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="pl-3 pr-3">
                        <div className="">
                            <div className="">
                                <div className="">
                                    <div className="input_name">
                                    </div>
                                    <div className="">
                                        <div className=" mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                            プロフィール
                                        </div>
                                        <div className="">
                                            <div className="mt-3">
                                                <div className="">
                                                    {this.profileImage()}
                                                </div>
                                                <div className="text-center mr-3"style={{marginRight:'5px'}}>
                                                    {this.editProfile()}
                                                </div>
                                            </div>
                                            <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto", fontSize: "13px" }}>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "15%"}}>性別</legend>
                                                    <span><div className="pb-1">{this.state.profile.sx}</div></span>
                                                </fieldset>
                                                <br/>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "30%"}}>都道府県選択</legend>
                                                    <span><div className="pb-1">{this.state.profile.area}</div></span>
                                                </fieldset>
                                                <br/>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "20%"}}>住所</legend>
                                                    <span>
                                                        <div className="col-md-7 pb-1" style={{ textAlign: "center", height: "50px" }}>
                                                            {(() => {
                                                                if (this.state.address !== null) {
                                                                    return (
                                                                        this.state.address.split('\n').map((item, key) =>
                                                                            <span key={key}>
                                                                                {item}
                                                                                <br />
                                                                            </span>
                                                                        )
                                                                    )
                                                                }
                                                            })()}
                                                        </div>
                                                    </span>
                                                </fieldset> 
                                                <br/>
                                            </div>
                                            <div className="mt-5" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto", fontSize: "13px" }}>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "30%"}}>ユーザー名</legend>
                                                    <span><div className="pb-1">{this.state.username}</div></span>
                                                </fieldset>
                                                <br/>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "25%"}}>電話番号</legend>
                                                    <span><div className="pb-1">{this.state.phone}</div></span>
                                                </fieldset>
                                                <br/>
                                                <fieldset className="fieldset_border">
                                                    <legend className="fieldset_legend" style={{width: "40%"}}>メールアドレス</legend>
                                                    <span><div className="pb-1">{this.state.email}</div></span>
                                                </fieldset>
                                                <br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                            プロフィール
                                    </div>
                                        <div className="container">
                                            <div className="mt-3 row" style={{ height: '100px' }}>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    {this.profileImage()}
                                                </div>
                                                <div className="col-md-4 text-right">
                                                    {this.editProfile()}
                                                </div>
                                            </div>
                                            <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto", }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>性別:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.profile.sx}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>都道府県選択:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.profile.area}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>住所:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left", height: "50px" }}>
                                                        {(() => {
                                                            if (this.state.address !== null) {
                                                                return (
                                                                    this.state.address.split('\n').map((item, key) =>
                                                                        <span key={key}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    )
                                                                )
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-5" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto" }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>ユーザー名:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.username}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>電話番号:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.phone}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>メールアドレス:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.email}
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>クレジットカード:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.creditcard}
                                                </div>
                                            </div> 
                                             <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>銀行口座情報:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {(() => {
                                                        if (this.state.t_account !== null) {
                                                            return (
                                                                this.state.t_account.split('\n').map((item, key) =>
                                                                    <span key={key}>
                                                                        {item}
                                                                        <br />
                                                                    </span>
                                                                )
                                                            )
                                                        }
                                                    })()}
                                                     {this.state.t_account} 
                                                </div>
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { BuyerProfile }